import _Typography from "@mui/material/Typography";
import _Box from "@mui/material/Box";
import React from 'react';
import { useTranslation } from 'react-i18next';
const specialCharacterRegex = /[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/;
function isLetter(character) {
  return character.toLocaleLowerCase() !== character.toLocaleUpperCase();
}
export function hasPasswordUppercase(password) {
  return Array.from(password).some(character => isLetter(character) && character === character.toLocaleUpperCase());
}
export function hasPasswordLowercase(password) {
  return Array.from(password).some(character => isLetter(character) && character === character.toLocaleLowerCase());
}
export function isValidPassword(password) {
  return password.length >= 8 && /\d/.test(password) && hasPasswordLowercase(password) && hasPasswordUppercase(password) && specialCharacterRegex.test(password);
}
export function PasswordValidation({
  password
}) {
  const {
    t
  } = useTranslation();
  const has8Characters = password.length >= 8;
  const has1Number = password.match(/\d/);
  const has1Uppercase = hasPasswordUppercase(password);
  const has1Lowercase = hasPasswordLowercase(password);
  const has1SpecialCharacter = specialCharacterRegex.test(password);
  return /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    columnGap: 2,
    display: "flex",
    flexWrap: "wrap"
  }, /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 1
  }, /*#__PURE__*/React.createElement(_Box, {
    bgcolor: has8Characters ? '#3DD693' : '#CFCFCF',
    borderRadius: 1,
    height: 8,
    width: 8
  }), /*#__PURE__*/React.createElement(_Typography, {
    variant: "caption"
  }, t('commons.sign_up_form.password_pattern_characters'))), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 1
  }, /*#__PURE__*/React.createElement(_Box, {
    bgcolor: has1Number ? '#3DD693' : '#CFCFCF',
    borderRadius: 1,
    height: 8,
    width: 8
  }), /*#__PURE__*/React.createElement(_Typography, {
    variant: "caption"
  }, t('commons.sign_up_form.password_pattern_digit'))), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 1
  }, /*#__PURE__*/React.createElement(_Box, {
    bgcolor: has1Uppercase ? '#3DD693' : '#CFCFCF',
    borderRadius: 1,
    height: 8,
    width: 8
  }), /*#__PURE__*/React.createElement(_Typography, {
    variant: "caption"
  }, t('commons.sign_up_form.password_pattern_uppercase'))), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 1
  }, /*#__PURE__*/React.createElement(_Box, {
    bgcolor: has1Lowercase ? '#3DD693' : '#CFCFCF',
    borderRadius: 1,
    height: 8,
    width: 8
  }), /*#__PURE__*/React.createElement(_Typography, {
    variant: "caption"
  }, t('commons.sign_up_form.password_pattern_lowercase'))), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 1
  }, /*#__PURE__*/React.createElement(_Box, {
    bgcolor: has1SpecialCharacter ? '#3DD693' : '#CFCFCF',
    borderRadius: 1,
    height: 8,
    width: 8
  }), /*#__PURE__*/React.createElement(_Typography, {
    variant: "caption"
  }, t('commons.sign_up_form.password_pattern_special_character'))));
}